<template>
    <div class="test"  style="background-image: url('/admission3.jpg'); background-size: cover; background-repeat: no-repeat">
        <div class="uk-padding-large " style="background-color: rgba(0, 0, 0, 0.7)">
            <div class="uk-container" style="height: 170px">
                <div class="uk-child-width-1-2@m" uk-grid>
                    <div class=" uk-light">
                        <h2 style="font-weight: bolder">Become an NCU Beacon</h2>

                    </div>
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ourLegacy"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h2{
            font-size: 1.4em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }

        .test{
            height: 230px !important;
        }


    }
</style>
